'use strict';

angular.module('licensure.services')
    .factory('Enterprise', ['$http', '$q', '$rootScope', 'Cache', function ($http, $q, $rootScope, Cache) {
        var processData = function (data) {
            data.PRODUCTNAME = 'LICENSURE';
            data.userLabels = [];
            data.serviceLabels = [];
            data.vehicleLabels = [];

            data.entities.forEach(function (entity) {
                if (entity.user) {
                    data.userLabels["USER"] = entity.label;
                }
                else if (entity.service) {
                    data.serviceLabels["SERVICE"] = entity.label;
                }
                else if (entity.vehicle) {
                    data.vehicleLabels["VEHICLE"] = entity.label;
                }

                entity.categories.forEach(function (category) {
                    if (entity.user) {
                        data.userLabels[category.name] = category.label;
                    }
                    else if (entity.service) {
                        data.serviceLabels[category.name] = category.label;
                    }
                    else if (entity.vehicle) {
                        data.vehicleLabels[category.name] = category.label;
                    }
                    category.fields.forEach(function (field) {
                        if (entity.user) {
                            data.userLabels[field.name] = field.label;
                        }
                        else if (entity.service) {
                            data.serviceLabels[field.name] = field.label;
                        }
                        else if (entity.vehicle) {
                            data.vehicleLabels[field.name] = field.label;
                        }
                    })
                })
            })
        }

        return {
            get: function (args) {
                var d = $q.defer();

                if ($rootScope.offline) {
                    Cache.get('enterprise', 'LICENSURE').then(function (enterprise) {
                        d.resolve(enterprise);
                    }).catch(function (response) {
                        d.reject(response.data);
                    });
                }
                else {

                    $http
                        .get(apiLocation + '/api/enterprise', {
                            params: args
                        })
                        .then(function (response) {
                            if (response.data != null) {
                                processData(response.data);
                                Cache.save('enterprise', response.data, 'PRODUCTNAME').then(function () {
                                    d.resolve(response.data);
                                }).catch(function (response) {
                                    d.reject(response.data);
                                });
                            }
                            else {
                                d.resolve(null);
                            }
                        })
                        .catch(function (response) {
                            // handle error
                        });

                    return d.promise;
                }
            },

            getLess: function (args) {
                var d = $q.defer();

                if ($rootScope.offline) {
                    Cache.get('enterprise', 'LICENSURE').then(function (enterprise) {
                        d.resolve(enterprise);
                    }).catch(function (response) {
                        d.reject(response.data);
                    });
                }
                else {

                    $http
                        .get(apiLocation + '/api/enterpriseLess', {
                            params: args
                        })
                        .then(function (response) {
                            if (response.data != null) {
                                processData(response.data);
                                Cache.save('enterprise', response.data, 'PRODUCTNAME').then(function () {
                                    d.resolve(response.data);
                                }).catch(function (response) {
                                    d.reject(response.data);
                                });
                            }
                            else {
                                d.resolve(null);
                            }
                        })
                        .catch(function (response) {
                            // handle error
                        });

                    return d.promise;
                }
            },

            getByAddress: function (address) {
                var d = $q.defer();

                if ($rootScope.offline) {
                    Cache.get('enterprise', 'LICENSURE').then(function (enterprise) {
                        d.resolve(enterprise);
                    })
                }
                else {
                    $http
                        .get(apiLocation + '/api/enterprise/getbyaddress', {
                            params: { address: address }
                        })
                        .then(function (response) {
                            if (response.data != null) {
                                processData(response.data)

                                Cache.save('enterprise', response.data, 'PRODUCTNAME').then(function () {
                                    d.resolve(response.data);
                                })
                            }
                            else {
                                d.resolve(null);
                            }
                        })
                        .catch(function () {
                            d.reject(response.data);
                        });

                    return d.promise;
                }
            },
            getlogoutSettings: function (id) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/enterprise/getLogoutCriteria', {
                    params: { enterpriseID: id }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },
            getUserVoiceLink: function () {
                var d = $q.defer();

                $http.get(apiLocation + '/api/Core/GetUserVoiceLink', {
                    params: {}
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getDuplicatePreventionText: function () {
                var d = $q.defer();

                $http.get(apiLocation + '/api/Core/DuplicatePreventionText', {
                    params: {}
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });
                return d.promise;
            },

            listPublicEnterpriseIdentityProvider: function () {
                var d = $q.defer();
                $http.get(apiLocation + '/api/AdminModule/ListPublicIdentityProvider', {
                    params: {}
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });
                return d.promise;
            },

            getEnterpriseUserPublicAddresses: function () {
                var d = $q.defer();
                $http.get(apiLocation + '/api/Core/EnterpriseShowUserPublicAddresses', {
                    params: {}
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });
                return d.promise;
            },

            getRecaptchaResponse: function (actionString, token) {
                var d = $q.defer();
                var enterpriseId = $rootScope.enterpriseID ? $rootScope.enterpriseID : "00000000-0000-0000-0000-000000000000";

                $http.get(apiLocation + '/api/enterprise/recaptchaTokenResponse', {
                    params: { actionString: actionString, token: token, enterpriseId: enterpriseId }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },
        }
    }])
    ;